const HOME_LINK_SELECTOR = '[data-app-home-link]';

export const navigateToActiveDashboard = (locationNode) => {
  locationNode.assign('/');
};

export const installHomeNavigation = (documentNode, navigateHome) => {
  const handleHomeClick = (event) => {
    const homeLink = event.target?.closest?.(HOME_LINK_SELECTOR);
    if (!homeLink) return;

    event.preventDefault();
    void navigateHome();
  };

  documentNode.addEventListener('click', handleHomeClick);
  return () => documentNode.removeEventListener('click', handleHomeClick);
};
